import { Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import { LogoutOutlined } from "@ant-design/icons";

export default function Logout() {
    const navigate = useNavigate();

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        navigate("/login");
        message.info("Logged out.");
    }

    return (
        <Button onClick={logout}><LogoutOutlined></LogoutOutlined></Button>
    )
}